import { render, staticRenderFns } from "./ModbusMasterList.vue?vue&type=template&id=3adfc694"
import script from "./ModbusMasterList.vue?vue&type=script&lang=js"
export * from "./ModbusMasterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports